import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'

import { css } from 'styled-components';
import { Card } from '@independent-software/typeui/controls/Card';
import { Number } from '@independent-software/typeui/formatters/Number';
import { Label } from '@independent-software/typeui/controls/Label';

import { System } from '../../resource';
import { Status } from '../../controls/Status/Status';

interface IProps {
  className?: string;
  children?: React.ReactNode;
  system: System;
  active?: boolean;
  onClick: (system: System) => void;
}

const DashboardCardBase = (props: IProps) => 
  <Card className={props.className} onClick={() => props.onClick(props.system)}>
    <Card.Content>
      <SystemName>{props.system.name}</SystemName>
    </Card.Content>
    <Card.Content align='center'>
      <InfoTable>
        <tbody>
          <tr>
            <td><Number value={props.system.stations_count} decimals={0}/></td><td>{props.system.stations_count === 1 ? 'station' : 'stations'}</td>
            <td><Number value={props.system.campaigns_count} decimals={0}/></td><td>{props.system.campaigns_count === 1 ? 'campaign' : 'campaigns'}</td>
          </tr>
          <tr>
            <td><Number value={props.system.samples_count} decimals={0}/></td><td>{props.system.samples_count === 1 ? 'sample' : 'samples'}</td>
            <td><Number value={props.system.parameters_count} decimals={0}/></td><td>{props.system.parameters_count === 1 ? 'parameter' : 'parameters'}</td>
          </tr>
          <tr>
            <td><Number value={props.system.results_count} decimals={0}/></td><td>{props.system.results_count === 1 ? 'result' : 'results'}</td>
          </tr>
        </tbody>
      </InfoTable>
    </Card.Content>
    <Card.Content secondary align='right'>
      <Label size="small" color="black"><Status enabled={props.active}/></Label>
    </Card.Content>
  </Card>

const SystemName = styled.div`
  text-align: center;
  margin: 8px 0 8px 0;
  font-weight: 500;
  font-size: 18px;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
`

const InfoTable = styled.table`
  width: 100%;
  td {
    width: 25%;
  }
  td:nth-child(2n+1) {
    font-weight: 500;
    text-align: right;
    padding-right: 8px;
  }
  td:nth-child(2n) {
    text-align: left;
    font-size: 80%;
    padding-right: 16px;
  }

`

const DashboardCard = styled(DashboardCardBase)`
  transition: opacity ease-in-out 200ms;
  opacity: 1;
  ${p => !p.active && css`
     & > div:nth-child(1),  & > div:nth-child(2) {
      opacity: 0.5;
     }
  `}
  user-select: none;
`
 
export { DashboardCard }
